import { useQuery } from '@tanstack/react-query';

import { AdminInfraInsightsResponse, getAdminInfraInsights } from '@/services/api/admin';

export const ADMIN_INFRA_INSIGHTS_QUERY_KEY = ['admin', 'infra-insights'];

export const useAdminInfraInsights = () => {
  const query = useQuery<AdminInfraInsightsResponse>({
    queryKey: ADMIN_INFRA_INSIGHTS_QUERY_KEY,
    queryFn: getAdminInfraInsights,
    staleTime: 5 * 60 * 1000,
  });

  return {
    insights: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
};
